module.exports = __webpack_public_path__ + "static/media/userTokenDashedLine.2514d685.svg";